export default __webpack_public_path__ + "img/da7c8c608fd95875371ecf2b95cb11e7.png";